import styled from "styled-components";
import { device } from "../../styles/devices";

export const HeaderContent = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    background-color: var(--color-white);
    padding: 1.5rem 0;
    box-shadow: 0 1px 8px rgba(0,0,0,0.15);

    @media ${device.tablet}{
        top: initial;
        bottom: 0;
        padding: 1rem 0;
    }

    a{
        font-size: 1rem;
        font-weight: var(--font-bold);
        line-height: 1.5rem;
        color: var(--color-title);
        transition: .3s;

        &:hover{
            color: var(--color-black-hover);
        }
    }

    nav{
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 1rem;

        .nav{
            &__close,
            &__toggle {
                display: none;

                @media ${device.tablet}{
                    display: block;
                }
            }
        }

        div:nth-child(2){
            @media ${device.tablet}{
                position: fixed;
                bottom: -100%;
                left: 0;
                width: 100%;
                background-color: var(--color-white);
                padding: 2rem 1.5rem 4rem;
                box-shadow: 0 -1px 4px rgba(0,0,0,0.15);
                border-radius: 1.5rem 1.5rem 0 0;
                transition: all .3s;
            }

            @media ${device.mobileSmall}{
                padding: 2rem 0.5rem 4rem;
            }
        }

        ul{
            display: flex;
            column-gap: 2rem;
            position: relative;

            @media ${device.tabletLarge}{
                column-gap: 1.3rem;
            }

            @media ${device.tablet}{
                display: grid;
                grid-template-columns: repeat(3,1fr);
                gap: 2rem;
            }

            @media ${device.mobileSmall}{
                column-gap: .3rem;
                row-gap: 1.5rem;
            }

            li{
                &:last-child{
                    @media ${device.tablet}{
                        position: absolute;
                        bottom: -3.5rem;
                        left: 0;
                    }
                }
            }

            a{
                display: flex;
                align-items: center;
                flex-direction: column;

                font-size: 1rem;
                font-weight: var(--font-medium);
                color: var(--color-title);
                transition: .3s;
                position: relative;

                @media ${device.mobileSmall}{
                    font-size: .9rem;
                }

                &:hover, 
                &.navMenu-active{
                    color: var(--color-black-hover);
                    
                    &::before{
                        content:'';
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: -4px;
                        width: 50%;
                        height: 2px;
                        background-color: var(--color-black-hover);
                        border-radius: 4px;

                        @media ${device.tablet}{
                            width: 20px;
                        }
                    }
                }
                
                i{
                    display: none;
                    
                    @media ${device.tablet}{
                        display: block;
                        font-size: 1.3rem;
                        color: var(--color-black);
                    }
                }
            }
        }

        & > div > i.uil-times{
            position: absolute;
            right: 1.3rem;
            bottom: 0.5rem;
            font-size: 1.5rem;
            color: var(--color-black);

            @media ${device.mobileSmall}{
                right: .5rem;
            }
        }

        div.nav__toggle{
            font-size: 1.6rem;
            cursor: pointer;
            color: var(--color-black);
        }

        div.darkmode-toggle{
            
            label{
                width: 55px;
                height: 24px;
                position: relative;
                display: block;
                background-color: #ebebeb;
                border-radius: 200px;
                box-shadow: inset 0px 5px 15px rgba(0,0,0,0.4), inset 0px -5px 15px rgba(255,255,255,0.4);
                cursor: pointer;
                transition: .3s all;

                &::after{
                    content: "";
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    border-radius: 50%;
                    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
                    background-color: #d8860b;
                    transition: .3s all;
                }

                &:hover::after{
                    width: 30px;
                }

                i {
                    font-size: 1rem;
                    position: absolute;
                    top: 1px;
                    z-index: 10;
                    transition: all .3s;

                    &.uil.uil-sun{
                        left: 3px;
                        color: #fff;
                    }
                    &.uil.uil-moon{
                        left: 51px;
                        color: #7e7e7e;
                        transform: translateX(-100%);
                    }
                }
            }

            input{
                width: 0;
                height: 0;
                visibility: hidden;
                display: none;

                &:checked + label{
                    background-color: #242424;

                    &:after{
                    left: 55px;
                    transform: translateX(-100%);
                    background-color: #3a3a3a;
                    }
                }
            }
        }
    }
`;

export const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;